import { setCookie, getCookie } from '../shared/cookieHelper';
// Imported explicitly rather than relying on the side-effect import in
// calculator/CMGCalc/calculator-common.js. Today's $('#search-form').valid() only
// works because it runs at click time, by which point every module has evaluated;
// the addMethod/validate() calls below run at init and need $.validator present.
import 'jquery-validation';
import { createUnitToggle } from '../shared/unitToggle';
import { copyText } from '../shared/copyText';
import {
    SellerConcessionUnit,
    SellerConcessionStatus,
    MinSellerConcessionPercent,
    MaxSellerConcessionPercent,
    evaluateConcessionEntry,
    convertConcessionToDollars,
    convertConcessionToPercent,
    hasUsableConversionBase,
    parseNumber
} from '../shared/concessionUnits';

const listNLockVideoGenerationTimeout = 300;

window.showTerms = function (element) {
    $('#terms-text').html(element);
    $('#modal-terms').show();
}

window.copyToClipboard = async function (element) {
    let textToCopy = '';

    // Determine what type of input we received
    if (typeof element === 'string') {
        // Check if it looks like a selector (starts with #, ., [, or other CSS selector chars)
        if (element.match(/^[#.\[]/)) {
            // It's likely a selector string, query it
            textToCopy = $(element).text();
        } else {
            // It's a plain string value to copy directly
            textToCopy = element;
        }
    } else if (element instanceof jQuery) {
        // It's already a jQuery object
        textToCopy = element.text();
    } else if (element instanceof HTMLElement) {
        // It's a DOM element
        textToCopy = $(element).text();
    } else {
        console.error('Invalid input type for copyToClipboard');
        return;
    }

    if (await copyText(textToCopy)) {
        alert("Copied");
    } else {
        alert("Failed to copy");
    }
}

// Google Places autocomplete for the sign rider / yard sign reorder dialog.
// Loaded as the Maps API callback from the List & Lock, Spec Lock and Builder
// Forward confirmation pages. It fills the hidden address parts and then raises
// 'addresspicked' on the input; each page's own script copies the parts into the
// visible address form (which the reorder posts from) and lets the LO finish a
// suggestion Google could not fully resolve by hand.
window.GinitMap2 = function () {
    var componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        administrative_area_level_2: 'long_name',
        country: 'long_name',
        postal_code: 'short_name'
    };
    var input = document.getElementById('autocomplete');
    var countries = 'us';

    // Only the three confirmation pages carry #autocomplete.
    if (!input) {
        return;
    }

    var autocomplete = new google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: countries },
        fields: ['address_components', 'name']
    });

    autocomplete.addListener('place_changed', function () {
        var place = autocomplete.getPlace();

        // Clear first so a second selection cannot leave stale parts behind
        // from the previous one.
        Object.keys(componentForm).forEach(function (addressType) {
            var field = document.getElementById(addressType);
            if (field) {
                field.value = '';
            }
        });

        // No details for the suggestion: leave the parts empty and let the page open
        // the manual form rather than interrupting the LO with an alert.
        if (!place || !place.address_components) {
            $(input).trigger('addresspicked');
            return;
        }

        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types && place.address_components[i].types[0];
            if (componentForm[addressType]) {
                var field = document.getElementById(addressType);
                if (field) {
                    field.value = place.address_components[i][componentForm[addressType]];
                }
            }
        }

        $(input).trigger('addresspicked');
    });
};

window.thisFileUpload = function () {
    document.getElementById("listingimagefile").click();
};

$(function () {
    if ($('#locknlist_home_page').length) {
        var $loading = $('#ll_loading-div').hide();
        var $loadingform = $('#ll_loading-div-form').hide();

        $('#selectState').on('change', function (e) {
            var optionSelected = $("option:selected", this);
            var stateCode = optionSelected.text()

            var loc = $("#prefixurl").val();

            $.ajax({
                url: loc + '/get-counties/' + stateCode,
                type: 'GET',
                beforeSend: function () {
                    $loadingform.show();
                },
                success: function (response) {
                    $loadingform.hide();
                    let dropdown = document.getElementById('selectCounty');
                    dropdown.length = 0;

                    let defaultOption = document.createElement('option');
                    defaultOption.text = 'Choose County';
                    defaultOption.value = "";

                    dropdown.add(defaultOption);
                    dropdown.selectedIndex = 0;
                    var obj = jQuery.parseJSON(response);

                    let sortedObj = obj.sort((a, b) => a.Name.localeCompare(b.Name));

                    let option;

                    for (let i = 0; i < sortedObj.length; i++) {
                        option = document.createElement('option');
                        option.text = sortedObj[i].Name;
                        option.value = sortedObj[i].Code;
                        dropdown.add(option);
                    }
                    $('#selectCounty').valid();
                }
            });
        });


        $('#btnFormStart').click(function (e) {
            $("#modaladdress_ll").validate();
            if ($('#modaladdress_ll').valid()) {
                e.preventDefault();
                var form = new FormData();
                setCookie("ll_state_error", "no", 1);
                var selectedState = document.getElementById("selectState");
                var s = selectedState.options[selectedState.selectedIndex].text;
                form.append("state_lisenced", $("#state_lisenced").val());
                var sl = $("#state_lisenced").val();
                form.append("member_id", $("#member_id").val());
                form.append("branch_orgid", $("#branch_orgid").val());
                form.append("street_no", document.getElementById('txtStreetNo').value);
                form.append("street", document.getElementById('txtStreet').value);
                form.append("suite_appt_floor", document.getElementById('txtSuiteAptFloor').value);
                form.append("city", document.getElementById('txtCity').value);
                form.append("zip", document.getElementById('txtZip').value);
                form.append("state_code", document.getElementById('selectState').value);
                form.append("county_code", document.getElementById('selectCounty').value);
                var loc = $("#prefixurl").val();
                setCookie("ll_prefix_url", loc, 1);
                if (sl.indexOf(s) < 0) {
                    setCookie("ll_state", s, 1);
                    setCookie("ll_state_error", "yes", 1);
                    window.location.href = loc;
                }
                else {
                    $.ajax({
                        url: loc + '/RateOptions',
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        beforeSend: function () {
                            $loading.show();
                        },
                        success: function (response) {
                            $loading.hide();
                            if (response == "ok")
                                window.location.href = loc + "/SearchRateOptions";
                            else
                                window.location.href = loc;
                        }
                    });
                }
            }
            else
                return false;
        });

        $("#btnStarted").attr("disabled", "disabled");
        $("#btnStarted").addClass("disabled");

        // No Maps API load here: the home page's address lookup was removed in
        // PR 27027, so #autocomplete no longer exists on this page and loading
        // Places only to have GinitMap2 return immediately is wasted billing.

        $('#btnStarted').click(function (e) {
            e.preventDefault();
            var form = new FormData();
            var selectedState = document.getElementById("selectState");
            var s = selectedState.options[selectedState.selectedIndex].text;
            setCookie("ll_state_error", "no", 1);
            form.append("state_lisenced", $("#state_lisenced").val());
            var sl = $("#state_lisenced").val();
            form.append("member_id", $("#member_id").val());
            form.append("branch_orgid", $("#branch_orgid").val());
            form.append("street_no", document.getElementById('txtStreetNo').value);
            form.append("street", document.getElementById('txtStreet').value);
            form.append("suite_appt_floor", document.getElementById('txtSuiteAptFloor').value);
            form.append("city", document.getElementById('txtCity').value);
            form.append("zip", document.getElementById('txtZip').value);
            form.append("state_code", document.getElementById('selectState').value);
            form.append("county_code", document.getElementById('selectCounty').value);
            var loc = $("#prefixurl").val();
            setCookie("ll_prefix_url", loc, 1);
            if (sl.indexOf(s) < 0) {
                setCookie("ll_state", s, 1);
                setCookie("ll_state_error", "yes", 1);
                window.location.href = loc;
            }
            else {
                $.ajax({
                    url: loc + '/RateOptions',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        $loading.hide();
                        if (response == "ok")
                            window.location.href = loc + "/SearchRateOptions";
                        else
                            window.location.href = loc;
                    }
                });
            }
        });

        $('#modal-confirmation').keypress(function (e) {
            if (e.keyCode == 13) {
                $('#btnConfirm').click();
            }
        });

        $('#btnConfirm').on('click',function (e) {
            e.preventDefault();

            var loc = $("#prefixurl").val();
            setCookie("ll_prefix_url", loc, 1);

                $.ajax({
                    url: loc + '/check?id=' + $("#txtConfirmationNumber").val(),
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    beforeSend: function () {
                        $loading.show();
                    },
                    data: "",
                    success: function (response) {
                        $loading.hide();
                        if (response.success)
                            window.location.href = response.redirectUrl
                    }
                });
        });

        $('#btnResent').click(function (e) {
            e.preventDefault();

            var loc = $("#prefixurl").val();
            setCookie("ll_prefix_url", loc, 1);
            var formData = new FormData();
            formData.append("resentemail", $("#txtREmail").val());
            $.ajax({
                url: loc + '/CheckAndResend',
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
                beforeSend: function () {
                    $loading.show();
                },
                success: function (response) {
                    $loading.hide();
                    if (response == "ok") {
                        window.location.href = loc + '/information?status=ok';
                    }
                    else {
                        window.location.href = loc + '/information?status=error';
                    }
                }
            });
        });

        $('#btnAlreadyExist').click(function (e) {
            e.preventDefault();

            var loc = $("#prefixurl").val();
            setCookie("ll_prefix_url", loc, 1);

            $.ajax({
                url: loc + '/AlreadyExist',
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: "",
                beforeSend: function () {
                    $loading.show();
                },
                success: function (response) {
                    $loading.hide();
                    if (response == "ok") {
                        window.location.href = loc + '/SearchRateOptions';
                    }
                }
            });
        });
    }

    if ($('#search_rate_options_page').length) {
        var $loading = $('#ll_loading-div');

        // ---- Seller concession: $ / % entry (issue #240) ----------------------
        //
        // Unlike the Confirmation page, the sales price is EDITABLE here, so the two
        // units can disagree about which one the user meant. The whole design is one
        // canonical number held in the unit it was typed in:
        //
        //   value  — the number, in the ANCHOR's unit
        //   anchor — the unit the user last typed in; the source of truth
        //   unit   — the unit currently displayed
        //
        // The displayed figure is always DERIVED from value and never read back as
        // truth. Every rule in AC-9 falls out of that shape rather than being coded
        // separately:
        //
        //   * Toggling is idempotent because the display is regenerated from value,
        //     so N toggles are N *first* conversions, not a chain of round trips.
        //   * Toggling never changes the anchor, because the toggle handler never
        //     writes anchor.
        //   * Only fresh typing re-anchors, because anchor is written in exactly one
        //     handler — the 'input' handler below.
        //   * Changing the sales price holds the anchored unit and recomputes the
        //     other, because renderConcession() derives from the anchor.
        var concession = { unit: SellerConcessionUnit.Percent, anchor: SellerConcessionUnit.Percent, value: null };
        var concessionToggle = null;

        // The initial switch into $ goes through the same toggle path as a user click,
        // so this suppresses the validation that path would otherwise trigger. Landing
        // on the page must never raise an error against a value the user has not
        // touched — including a legacy row whose stored concession is out of range.
        var concessionInitializing = true;

        // Has the USER typed in each field, as opposed to the page seeding it or a
        // toggle deriving it? Written only by the `input` handlers below — `.val()`
        // writes fire no `input` event, so a rendered conversion never counts as an
        // edit. This is what the blur-time exemption keys on; see the onfocusout
        // override. Guards the same intent as `concessionInitializing`, but for the
        // whole session rather than just page load.
        var concessionFieldsEdited = { sellerinput: false, salesinput: false };

        function salesPriceValue() {
            return parseNumber($('#salesinput').val());
        }

        // The value expressed in a given unit, or null when it cannot be expressed
        // (no usable conversion base).
        function concessionIn(unit) {
            if (concession.value === null) {
                return null;
            }

            if (unit === concession.anchor) {
                return concession.value;
            }

            return unit === SellerConcessionUnit.Dollar
                ? convertConcessionToDollars(concession.value, salesPriceValue())
                : convertConcessionToPercent(concession.value, salesPriceValue());
        }

        function renderConcession() {
            var derived = concessionIn(concession.unit);

            // Refuse to write null. Below the conversion floor there is nothing to
            // show, and blanking the field would destroy what the user typed — AC-8's
            // sub-threshold no-op.
            if (derived !== null) {
                $('#sellerinput').val(derived);
            }
        }

        function applyConcessionConstraints() {
            var $input = $('#sellerinput');
            var isDollar = concession.unit === SellerConcessionUnit.Dollar;
            var price = salesPriceValue();

            var min = isDollar ? convertConcessionToDollars(MinSellerConcessionPercent, price) : MinSellerConcessionPercent;
            var max = isDollar ? convertConcessionToDollars(MaxSellerConcessionPercent, price) : MaxSellerConcessionPercent;

            if (isDollar && min !== null && max !== null) {
                // Dollar bounds for the current price.
                $input.attr({ min: min, max: max, step: '1' });
            } else if (isDollar) {
                // Dollar mode with NO usable conversion base. The native min/max are
                // REMOVED, not left at their percent values: AC-8 requires that "the
                // leftover static max='6' attribute must not fire against a dollar
                // figure". Dollar bounds are skipped entirely until a price exists —
                // submission is blocked by the Sales Price field's own `required`,
                // and adding an error here would be the duplicate AC-8 forbids.
                $input.removeAttr('min').removeAttr('max').attr('step', '1');
            } else {
                $input.attr({ min: MinSellerConcessionPercent, max: MaxSellerConcessionPercent, step: '0.01' });
            }

            $input.toggleClass('icon-left', isDollar).toggleClass('icon-right', !isDollar);

            $('#sellerinput_label').text(isDollar
                ? 'Seller Concession to Buy Down Rate ($)'
                : 'Seller Concession to Buy Down Rate (' + MinSellerConcessionPercent + '-' + MaxSellerConcessionPercent + '%)');

            // Swap which rule set is live. Setting a param to false DELETES the rule
            // (jquery.validate.js), so in % mode the rules, messages and rendered
            // error are literally the ones that run today — a reviewer can confirm
            // "% is unchanged" by inspection rather than by testing.
            if ($input.data('validator-attached')) {
                $input.rules('add', isDollar
                    ? { min: false, max: false, concessionBounds: true }
                    : { min: MinSellerConcessionPercent, max: MaxSellerConcessionPercent, concessionBounds: false });
            }
        }

        // NOTE: this page deliberately has NO unit-availability logic — no disabling of
        // the $ button and no automatic switch to %. That is the Confirmation page's
        // behaviour (AC-11b) and it must NOT be generalised here:
        //
        //   AC-8: "the input accepts the keystrokes and no error is raised while
        //          typing — the field is not disabled"
        //   AC-9: "the active unit is unchanged by this — committing a sub-threshold
        //          Sales Price never switches the toggle mid-session on this page"
        //
        // The difference is that this page's Sales Price is being entered right now, so
        // it is legitimately unusable for most of the session; the Confirmation page's
        // is already fixed and known. Disabling $ here made dollar entry impossible
        // before a price was typed, and every keystroke into Sales Price (which at the
        // time started by clearing itself) briefly ejected the user from $ mode.
        //
        // Sub-threshold safety comes from renderConcession() refusing to write a null
        // and from the seam reporting NoConversionBase, which the validator treats as
        // passing so the Sales Price field owns the error.

        $(document).ready(function () {
            $loading.hide();
            document.getElementById("hdnNoOfUnits").value = 1;
            $('select').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                document.getElementById("hdnNoOfUnits").value = this.value;
            });

            // Bounds for $ mode. The param is evaluated live on every check
            // (jquery.validate.js), so the rule needs registering only once even
            // though the sales price it depends on keeps changing.
            $.validator.addMethod('concessionBounds', function (value, element) {
                if (this.optional(element)) {
                    return true;
                }

                var result = evaluateConcessionEntry(value, concession.unit, salesPriceValue());

                // NoConversionBase is NOT a concession error — the sales price is the
                // thing at fault, and its own `required`/`min` rules will say so.
                // Failing here too would show two errors for one mistake.
                return result.status === SellerConcessionStatus.Valid
                    || result.status === SellerConcessionStatus.NoConversionBase;
            }, function (params, element) {
                // Recomputed at display time rather than cached during validation, so
                // the message can never describe a state the field has moved on from.
                var result = evaluateConcessionEntry($(element).val(), concession.unit, salesPriceValue());
                return result.message
                    || 'Seller concession should be within ' + MinSellerConcessionPercent
                       + '-' + MaxSellerConcessionPercent + '% range.';
            });

            // Eager init. This IS a behaviour change: today the validator does not
            // exist until the first #btnSearch click, so blur validates nothing.
            // Eager init is what makes blur-time bounds possible at all.
            $('#search-form').validate({
                // #btnSearch is <input type="submit"> and the form has no action, so
                // without this an Enter keypress reloads the page. The click handler
                // below remains the only path that runs a search.
                submitHandler: function () {
                    return false;
                },
                onkeyup: function (element, event) {
                    // Bounds are a blur-time decision for the concession field: in $
                    // mode every keystroke on the way to "18000" is below minimum.
                    if (element.id === 'sellerinput') {
                        return;
                    }

                    $.validator.defaults.onkeyup.call(this, element, event);
                },
                onfocusout: function (element, event) {
                    // Do not validate a field the user has not touched. Eager validator
                    // init (new with the $/% work) is what would otherwise make tabbing
                    // through either field raise an error against a value they never
                    // typed — including a legacy row whose stored concession is outside
                    // 1-6%, or a stored sales price outside this field's own min/max.
                    //
                    // This keys on `concessionFieldsEdited`, NOT on the field being
                    // empty. It used to test `val() === ''`, which worked only as a side
                    // effect of the inline onfocus clearing the field on every focus.
                    // That clear was removed (it destroyed the user's input on tab-through
                    // and made AC-9 impossible to demonstrate), so emptiness no longer
                    // stands in for "untouched". Do not simplify this back.
                    if ((element.id === 'sellerinput' || element.id === 'salesinput')
                        && !concessionFieldsEdited[element.id]
                        && !(element.name in this.submitted)) {
                        return;
                    }

                    $.validator.defaults.onfocusout.call(this, element, event);
                }
            });
            $('#sellerinput').data('validator-attached', true);

            // Seed from the server-rendered percent. A fresh scenario renders 0, which
            // is "no saved concession", not a value of zero.
            var seeded = parseNumber($('#sellerinput').val());
            var hasSavedConcession = seeded !== null && seeded > 0;

            if (hasSavedConcession) {
                concession.value = seeded;
                concession.anchor = SellerConcessionUnit.Percent;
            }

            concessionToggle = createUnitToggle(document.getElementById('concession_unit_toggle'), {
                onChange: function (unit) {
                    // Note what is NOT here: concession.anchor is never written. That
                    // single omission is what makes toggling non-destructive.
                    concession.unit = unit;
                    applyConcessionConstraints();
                    renderConcession();

                    // Re-check only an error already on screen, so toggling can clear a
                    // stale message but can never be what first raises one.
                    if (!concessionInitializing && $('#sellerinput').hasClass('error')) {
                        $('#search-form').validate().element('#sellerinput');
                    }
                }
            });

            // Starting unit, per AC-1 and AC-1b:
            //   no saved concession           -> $  (AC-1, regardless of sales price)
            //   saved + usable base           -> $  showing the dollar equivalent (AC-1b)
            //   saved + unusable base         -> %  showing the saved percentage (AC-1b),
            //                                      because there is nothing to convert against
            //
            // The first case is why this is NOT gated on hasUsableConversionBase: a fresh
            // scenario has no sales price yet, and gating would open every new lock in %.
            var startUnit = (!hasSavedConcession || hasUsableConversionBase(salesPriceValue()))
                ? SellerConcessionUnit.Dollar
                : SellerConcessionUnit.Percent;

            // Routed through the toggle so the initial switch takes the same path a user
            // click would.
            if (concessionToggle) {
                concessionToggle.setUnit(startUnit);
            }

            applyConcessionConstraints();
            concessionInitializing = false;

            // The ONLY place anchor is written. Typing is what re-anchors; nothing
            // else may.
            $('#sellerinput').on('input', function () {
                var typed = parseNumber($(this).val());

                concessionFieldsEdited.sellerinput = true;
                concession.anchor = concession.unit;
                concession.value = typed;
            });

            // A price change holds the anchored unit and recomputes the other one. The
            // unit itself is never touched here — see the note above.
            //
            // 'input' only re-renders. Validating mid-keystroke would fire against the
            // transient states Sales Price passes through — typing over the selected
            // value means "300000" starts life as "3" — which AC-8 forbids.
            $('#salesinput').on('input', function () {
                concessionFieldsEdited.salesinput = true;
                applyConcessionConstraints();
                renderConcession();
            });

            // 'change'/'blur' is the COMMIT. AC-9 requires that recomputing against a
            // new price actually surfaces the bound error — without this the field
            // silently held an out-of-range value until the user blurred it or clicked
            // Search.
            $('#salesinput').on('change blur', function () {
                applyConcessionConstraints();
                renderConcession();

                // Only re-validate a concession the user actually entered. Keyed on the
                // edited flag rather than on the field being non-empty: the field is now
                // populated on load and stays populated through a tab-through, so
                // non-emptiness no longer implies the user put it there.
                if (!concessionInitializing && concessionFieldsEdited.sellerinput) {
                    $('#search-form').validate().element('#sellerinput');
                }
            });
        });
        $('#multi').change(function () {
            if (this.checked) {
                $('#div-multi').css("display", "block");
                document.getElementById("noUnits").attr('required', '');
            } else {
                $('#div-multi').css("display", "none");
                $("#noUnits").removeAttr('required');
                document.getElementById("hdnNoOfUnits").value = 1;
            }
        });

        $('#btnSearch').click(function (e) {
            e.preventDefault();
            if ($('#search-form').valid()) {
                if ($('#multi').is(":checked")) {
                    var n = document.getElementById("hdnNoOfUnits").value;
                    if (n < 2) {
                        alert("Please select the No. of Units");
                        return false;
                    }
                }
                var form = new FormData();

                // Post the canonical PERCENTAGE whichever unit is on screen — the
                // endpoint reads sellerconcession as a percent and the column stores
                // one. The conversion goes into the PAYLOAD ONLY, never back into the
                // DOM, so a slow or failed request leaves the form exactly as the user
                // left it.
                var submittedPercent = concessionIn(SellerConcessionUnit.Percent);

                if (submittedPercent === null) {
                    // Fail CLOSED. This is only reachable when the value is dollar-anchored
                    // with no usable conversion base — i.e. Sales Price is empty or below
                    // its own min="50000", so .valid() has already blocked us. Falling back
                    // to the raw DOM value would post a dollar figure that the server reads
                    // as a percent, which is the exact 39000%-on-the-flyer hazard this
                    // feature is built to avoid.
                    return false;
                }

                form.append("sellerconcession", submittedPercent);
                form.append("salesprice", document.getElementById('salesinput').value);
                form.append("noUnits", document.getElementById('hdnNoOfUnits').value);

                form.append("propertytype", $("input:radio[name='propertytype']:checked").val());
                form.append("contribution_cmg", document.getElementById('contribution_CMG').value);
                form.append("contribution_agent", "0.00");
                var loc1 = $("#prefixurl").val();
                $.ajax({
                    url: loc1 + '/get-rate-options',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        if (response == "ok") {
                            window.location.href = loc1 + '/search-rate-result';
                        }
                        else if (response == "nodata") {
                            window.location.href = loc1 + '/search-rate-result';
                        }
                        else {
                            window.location.href = loc1;
                        }
                    }
                });
            }
            else
                return false;
        });
    }

    if ($('#ll_property_page').length) {
        $(function () {
            $(document).on("click", ".popover .close", function () {
                $(this).parents(".popover").popover('hide');
            });

            $(document).ready(function () {
                $(":input").inputmask();

                $("#phone").inputmask("(999) 999-9999", { clearIncomplete: true });
            });

            $('#email').on('input', function () {
                validateEmail(this);
            });

            $('#firstname').on('input', function () {
                validateFirstName(this);
            });
            $('#lastname').on('input', function () {
                validateLastName(this);
            });
            function validateFirstName(input) {
                var a = input.value;
                const errorMessage = document.getElementById('error-message-firstname');
                if (a.trim().length <= 0) {
                    errorMessage.textContent = 'This field is required.';
                    $('#btnPropertyEnquirySubmit').prop('disabled', true);
                }
                else {
                    errorMessage.textContent = '';
                    $('#btnPropertyEnquirySubmit').prop('disabled', false);
                }
            };

            function validateLastName(input) {
                var a = input.value;
                const errorMessage = document.getElementById('error-message-lastname');
                if (a.trim().length <= 0) {
                    errorMessage.textContent = 'This field is required.';
                    $('#btnPropertyEnquirySubmit').prop('disabled', true);
                }
                else {
                    errorMessage.textContent = '';
                    $('#btnPropertyEnquirySubmit').prop('disabled', false);
                }
            };
            $('#modal-PropertyEnquiry').keypress(function (e) {
                if (e.keyCode == 13) {
                    $('#btnPropertyEnquirySubmit').click();
                }
            });

            function validateEmail(input) {
                const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                const errorMessage = document.getElementById('error-message');
                if (!emailPattern.test(input.value)) {
                    errorMessage.textContent = 'Invalid email format';
                    $('#btnPropertyEnquirySubmit').prop('disabled', true);
                }
                else {
                    errorMessage.textContent = '';
                    $('#btnPropertyEnquirySubmit').prop('disabled', false);
                }
            };

            $('#btnPropertyEnquirySubmit').on('click', function (e) {
                e.preventDefault();

                if ($('#modalPropertyEnquiry-form').valid()) {
                    var form = new FormData();

                    var fn = document.getElementById('firstname').value.trim();
                    var ln = document.getElementById('lastname').value.trim();
                    var ph = document.getElementById('phone').value.trim();
                    var email = document.getElementById('email').value.trim();

                    if (fn == '' || ln == '' || ph == '' || email == '' ) {
                        return false;
                    }

                    form.append("lisitingadd", document.getElementById('hdnListingAdd').value.trim());
                    form.append("firstname", document.getElementById('firstname').value.trim());
                    form.append("lastname", document.getElementById('lastname').value.trim());
                    form.append("phone", document.getElementById('phone').value.trim());
                    form.append("email", document.getElementById('email').value.trim());
                    form.append("sellerid", document.getElementById('hdnSellerID').value.trim());
                    form.append("loannumber", document.getElementById('hdnConfirmationNumber').value.trim());
                    form.append("confirmationUrl", window.location.hostname + document.getElementById('prefixurl').value.trim() + "/confirmation?id=" + document.getElementById('hdnConfirmationNumber').value.trim());


                    $.ajax({
                        url: $("#prefixurl").val() + "/property-enquiry-submit",
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        success: function (response) {
                            if (response == "ok") {
                                $("#modal-PropertyEnquiry").modal("hide");
                                $("#modal-propertyEnquirysuccess").modal("show");
                            }
                            else {
                                $("#modal-PropertyEnquiry").modal("hide");
                                $("#modal-propertyEnquiryfailure").modal("show");
                            }
                        }
                    });
                }
                else {
                    return false;
                }
            });
            var genericCloseBtnHtml = '<button onclick="$(this).closest(\'div.popover\').popover(\'hide\');" type="button" class="close" aria-hidden="true">&times;</button>';

            $('[data-toggle="popover"]').popover({
                html: true,
                content: function () {
                    return $(this).next('.popper-content').html();
                }
            });

            $('[data-toggle="popover"]').on('click', function (e) {
                $('[data-toggle="popover"]').not(this).popover('hide');
            });

            $('[data-toggle="tooltip"]').tooltip();

            // Poll for property video completion when it is still pending
            if ($('#property_video').is('.pending')) {
                var propertyVideoCounter = 0;

                var cTimer = setInterval(() => {
                    $.get("/list-n-lock/video-upload-status?confirmation=" + $('#hdnConfirmationNumber').val() + "&type=property")
                        .done(function (data, textStatus, jqXHR) {
                            if (data.status === 'Error') {
                                propertyVideoCounter = listNLockVideoGenerationTimeout;
                                $('#instructions-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                                clearInterval(cTimer);
                                return;
                            }

                            if (data.videoUrl && data.videoUrl.length > 0) {
                                propertyVideoCounter = listNLockVideoGenerationTimeout;

                                // Use the existing house image thumbnail if available; otherwise fall back to video preview
                                var existingThumbnail = $('#property_video [data-role="thumbnail"]').attr('data-src');
                                var thumbnailUrl = (existingThumbnail && existingThumbnail.length > 0 && !existingThumbnail.includes('ll-loading.gif'))
                                    ? existingThumbnail
                                    : data.previewURL;

                                if (thumbnailUrl && thumbnailUrl.length > 0) {
                                    $('#property_video [data-role="thumbnail"]').attr('data-src', thumbnailUrl);
                                    $('#property_video [data-role="thumbnail"]').css('background-image', 'url("' + thumbnailUrl + '")');
                                }
                                $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);

                                $('#property_video').removeClass('pending');
                                $('#property_video_loading').addClass('d-none');
                                new VideoPlayer();
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            propertyVideoCounter = listNLockVideoGenerationTimeout;
                        })
                        .always(function () {
                            propertyVideoCounter++;

                            if (propertyVideoCounter > listNLockVideoGenerationTimeout) {
                                $('#instructions-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                                clearInterval(cTimer);
                            }
                        });
                }, 1000);
            }

            // If collaterals are regenerating, poll for the flyer completion and re-enable the download button
            if ($('#hdnCollateralsRefresh').val() === 'true') {
                var flyerPollCounter = 0;
                var flyerTimer = setInterval(() => {
                    $.get("/list-n-lock/video-upload-status?confirmation=" + $('#hdnConfirmationNumber').val() + "&type=flyer")
                        .done(function (data) {
                            if (data.status === 'Error') {
                                flyerPollCounter = listNLockVideoGenerationTimeout;
                                $('#flyerErrorMsg').text('Unable to generate flyer. Please try again from the confirmation page.').show();
                                clearInterval(flyerTimer);
                                return;
                            }

                            if (data.documentUrl && data.documentUrl.length > 0) {
                                flyerPollCounter = listNLockVideoGenerationTimeout;
                                $('#flyerDownloadLink').attr('href', data.documentUrl).removeClass('disabled');
                                clearInterval(flyerTimer);
                            }
                        })
                        .fail(function () {
                            flyerPollCounter = listNLockVideoGenerationTimeout;
                        })
                        .always(function () {
                            flyerPollCounter++;
                            if (flyerPollCounter > listNLockVideoGenerationTimeout) {
                                $('#flyerErrorMsg').text('Flyer generation timed out. Please try again from the confirmation page.').show();
                                clearInterval(flyerTimer);
                            }
                        });
                }, 3000);
            }

        });
    }

    if ($('#locknlist_esign_page').length) {
        $('iframe').on('load', function () {
            $('iframe').contents().find("head")
                .append($("<style type='text/css'> #welcome-wrapper{display:none;}  </style>"));
        });
    }

    if ($('#locknlist_payment_success').length) {
        var returnUrl = $('#locknlist_payment_success').data('url');

        createLoan(returnUrl, 0);
    }

    // Issue #380: pre-generate the two presentation pages on Search Rate Result load (async), so by the
    // time the LO opens "Download Listing Presentation" (which opens CreatePresentation in a new tab)
    // the pages are already generating/ready and that page only has to merge them. Inputs are immutable
    // once on this page and any change re-loads it, so generating here is always fresh. The background
    // endpoints set each page column to "Pending" immediately, so the Presentation page's needsGeneration()
    // guard then skips regeneration and goes straight to merge polling.
    if ($('#search_rate_result_page').length) {
        var llPresentationSellerId = (function () {
            var m = document.cookie.match(/(?:^|;\s*)ll_id=([^;]+)/);
            return m ? decodeURIComponent(m[1]) : '';
        })();

        if (llPresentationSellerId) {
            $.post('generate-presentationpage1-background?sessionid=' + llPresentationSellerId)
                .fail(function (xhr, status, error) {
                    console.error(`Error pre-generating presentation page 1 on search results. Status: ${status} error: ${error}`);
                });
            $.post('generate-presentationpage2-background?sessionid=' + llPresentationSellerId)
                .fail(function (xhr, status, error) {
                    console.error(`Error pre-generating presentation page 2 on search results. Status: ${status} error: ${error}`);
                });
        }
    }

    if ($('#locknlist_presentation_page').length) {
        var page1Url = $('#hdnUrl1').val();
        var page2Url = $('#hdnUrl2').val();
        var presentationUrl = $('#hdnUrl').val();

        // Helper function to check if URL needs generation
        function needsGeneration(url) {
            return url.length === 0 ||
                   url.startsWith("ERROR:") ||
                   url === "Resource URL is not provided";
        }

        if (presentationUrl.length > 0 && presentationUrl != "Pending" && !presentationUrl.startsWith("ERROR:")) {
            $("#pdfimg").attr("src", page1Url);
            return;
        }

        var $loading = $('#ll_loading-div').hide();
        $("#pdfimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");

        if (needsGeneration(page1Url)) {
            $.post('generate-presentationpage1-background?sessionid=' + $('#hdnID').val())
                .done(function (data) {
                    $('#hdnUrl1').val("Pending");
                })
                .fail(function (xhr, status, error) {
                    console.error(`Error in generate-presentationpage1-background. Status: ${status} error: ${error}`);
                    $('#hdnUrl1').val("ERROR: Failed to start generation");
                });
        }

        if (needsGeneration(page2Url)) {
            $.post('generate-presentationpage2-background?sessionid=' + $('#hdnID').val())
                .done(function (data) {
                    $('#hdnUrl2').val("Pending");
                })
                .fail(function (xhr, status, error) {
                    console.error(`Error in generate-presentationpage2-background. Status: ${status} error: ${error}`);
                    $('#hdnUrl2').val("ERROR: Failed to start generation");
                });
        }

        if ($('#merge_pdf').is('.pending')) {
            var pdfCounter = 0;
            var id = $('#hdnID').val();
            var cTimer = setInterval(() => {
                $.get("pdf-upload-status?id=" + $('#hdnID').val() + "&type=presentation")
                    .done(function (data, textStatus, jqXHR) {
                        // Issue #380: the server now reports a terminal failure explicitly, so stop
                        // polling and show the banner immediately instead of waiting out all 90 polls.
                        if (data.failed) {
                            pdfCounter = 91;
                            clearInterval(cTimer);
                            $('#instructions-div p').text('Unable to generate presentation file. Please try again.').addClass('upload-error');
                            return;
                        }
                        if (data.pdfUrl && data.pdfUrl.length > 0) {
                            pdfCounter = 90;
                            $('#instructions-div').addClass('d-none');
                            $('.heading-row').removeClass('d-none');
                            $('#merge_pdf').removeClass('pending');
                            $('#pdflink').attr('href', data.pdfFile);
                            $("#pdfimg").attr("src", data.previewURL);
                        }
                    })
                    .fail(function (xhr, status, error) {
                        console.error(`Error in pdf-upload-status request. Status: ${status} error: ${error}`);
                        pdfCounter = 90;
                    })
                    .always(function () {
                        pdfCounter++;

                        if (pdfCounter > 90) {
                            $('#instructions-div p').text('Unable to generate presentation file. Please try again.').addClass('upload-error');
                            clearInterval(cTimer);
                        }
                    });
            }, 2000);
        }
    }
});

function createLoan(url, retryAttempt) {
    $.post(url)
        .done(function (data) {
            if (data.success) {
                window.location.href = data.redirectUrl;
            }
            else {
                $('.label-error').removeClass('d-none');
                $('.dev-error h6').text(data.errorMessage);
                $('.label').addClass('d-none');
                $('img').addClass('d-none');
            }
        })
        .fail(function (xhr, status, error) {
            if (xhr.status === 503) {
                alert.log('error 503')
                retryAttempt++;
                if (retryAttempt < 4) {
                    createLoan(returnUrl, retryAttempt);
                    return;
                }
            }

            $('.label-error').removeClass('d-none');
            $('.dev-error h6').text(`Communication error. xhr: ${JSON.stringify(xhr)}, status: ${JSON.stringify(status)} error: ${JSON.stringify(error)}`);
            $('.label').addClass('d-none');
            $('img').addClass('d-none');
        });

    setTimeout(() => {
        location.reload();
    }, 300000);
}
